const fakeFileInputBtn = document.querySelector('.file-input__btn')
const realFileInputBtn = document.querySelector('.file-input__input')
/*
function addFileMessage() {
  let message = document.querySelector(".file-upload-message");
  realFileInputBtn.addEventListener("change", (e) => {

    let uploadValue = e.srcElement.value.replace(/^.*[\\\/]/, '');
    uploadValue = encodeURI(uploadValue);
    message.innerHTML = uploadValue;

  });
}
*/
if (fakeFileInputBtn) {
  const btnText = fakeFileInputBtn
    .closest('.form__input')
    .previousElementSibling.textContent.split('*')[0]
    .trim()

  //Set button text
  fakeFileInputBtn.textContent = btnText
  fakeFileInputBtn.setAttribute('data-text', btnText)

  fakeFileInputBtn.addEventListener('click', () => {
    //Click on real file input
    realFileInputBtn.click()
  })

  addFileMessage()
}

function addFileMessage() {
  if (realFileInputBtn) {
    let message = document.querySelector('.file-upload-message')
    realFileInputBtn.addEventListener('change', (e) => {
      let uploadValue = e.srcElement.value.replace(/^.*[\\\/]/, '')
      uploadValue = encodeURI(uploadValue)
      message.innerHTML = uploadValue
    })
  }
}

addFileMessage()
